import React from "react";
import "./style.scss";

const DraggableTable = ({ text }) => {
  const handleDrag = (event) => {
    event.dataTransfer.setData("text/plain", JSON.stringify(text));
  };

  const borderStyle = {
    border: `1px solid ${text.color ? text.color : "red"}`,
  };

  return (
    <div className="draggable-floor-item">
      <span
        style={borderStyle}
        className="draggable-table-num"
        draggable
        onDragStart={handleDrag}
      >
        Top {text?.occupancy}
      </span>
      <span className="number-table">x {text?.number_of_table}</span>
    </div>
  );
};

export default DraggableTable;
